import React, { Component } from 'react';
import _ from 'lodash';

class ResultItem extends Component {
	constructor(props) {
		super(props);
		this.state = {};		
	}
	static getDerivedStateFromProps(nextProps) {
		const { results } = nextProps.data;
		console.log('ResultItem data:', nextProps.data);
		console.log('Results:', results);
		if (!results || !Array.isArray(results)) {
			console.log('No results array, returning empty state');
			return {};
		}
		const newState = _.reduce(
			results,
			(accumulator, currentValue, index) => {
				console.log(`Processing result[${index}]:`, currentValue);
				if (!currentValue) {
					console.log(`Result[${index}] is null/undefined`);
					return accumulator;
				}
				if (!currentValue.answers) {
					console.log(`Result[${index}] has no answers property:`, currentValue);
					return accumulator;
				}
				const { inputName, value } = currentValue.answers;
				if (!inputName) {
					console.log(`Result[${index}] answers has no inputName:`, currentValue.answers);
				}
				return { ...accumulator, [inputName]: { inputName, value } };
			},
			{}
		);
		console.log('New state:', newState);
		return newState;
	}	
	renderResults() {
		return _.map(this.state, (item, i) => {
			return (
				<tr key={i}>
					<th scope="row">{item.inputName}</th>
					<td>{item.value.join()}</td>
				</tr>
			);
		});
	}
	render() {
		return (
			<div className="mb-5">
				<div>
					<strong>Id Usuario:</strong> {this.props.data.userId}
				</div>
				<table className="table table-striped">
					<thead className="thead-light">
						<tr>
							<th scope="col">Identificador</th>
							<th scope="col">Opciones seleccionadas</th>
						</tr>
					</thead>
					<tbody>{this.renderResults()}</tbody>
				</table>
				<hr />
			</div>
		);
	}
}

export default ResultItem;



// WEBPACK FOOTER //
// ./src/components/Admin/surveys/Results/ResultItem.js